import { z } from 'zod';
import { PlaybookSchema } from '../schemas/playbook.dto';
import { createToolSignature } from './tool-signature';

const PlaybooksToolResultSchema = z.object({
    playbooks: z.array(PlaybookSchema),
});

export const getAllPlaybooksToolSignature = createToolSignature({
    name: 'getAllPlaybooksTool',
    description:
        'Get all playbooks. Returns a list of all playbooks including the groupId of each playbook and the assistantSettings. This tool is a good starting point when you get a question about a playbook.',
    inputSchema: z.object({}),
    outputSchema: PlaybooksToolResultSchema,
    toolCallUi: (input) => `Checking your playbooks`,
});

export const addContactToPlaybookToolSignature = createToolSignature({
    name: 'addContactToPlaybookTool',
    description:
        'Move or add contacts to a playbook. Requires the prospectId of any existing contacts that should be moved, or the linkedinMemberIds of contacts that should be added and assigned to the playbook. Returns a list of the prospectIds that were added to the playbook.',
    inputSchema: z
        .object({
            groupId: z.string().describe('The groupId of the playbook to add the contacts to'),
            prospectIds: z
                .array(z.string())
                .describe(
                    'The prospectIds of the existing contacts that should be moved to the playbook. Empty array if you don`t want to move any contacts using this field',
                ),
            linkedinMemberIds: z
                .array(z.string())
                .describe(
                    'The linkedinMemberIds of the contacts that should be added and assigned to the playbook. Empty array if you don`t want to add any contacts using this field',
                ),
            linkedinProfileUrls: z
                .array(z.string())
                .describe(
                    'The linkedinProfileUrls of the contacts that should be added and assigned to the playbook. Is on the format linkedin.com/in/{slug}. Empty array if you don`t want to add any contacts using this field',
                ),
        })
        .describe(
            "All fields are required, pass an empty array if you don't want to add any contacts using that field",
        ),
    outputSchema: z.object({
        successfullyAddedProspectIds: z
            .array(z.string())
            .describe('The prospectIds of the contacts that were added to the playbook'),
    }),
    toolCallUi: (input) => {
        if (!input.prospectIds && !input.linkedinMemberIds && !input.linkedinProfileUrls) return null;

        const prospectCount = input.prospectIds?.length || 0;
        const linkedinMemberCount = input.linkedinMemberIds?.length || 0;
        const linkedinUrlCount = input.linkedinProfileUrls?.length || 0;

        return `Adding ${prospectCount + linkedinMemberCount + linkedinUrlCount} contacts to playbook`;
    },
});
